module.exports = __webpack_public_path__ + "img/握手.1cfc410b.png";